/* eslint angular/document-service: 0 */
(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'youku', {
            bindings: {
                id:   '<',
                play: '='
            },
            templateUrl:  'app/views/partials/widgets/youku.html',
            controller:   YoukuController,
            controllerAs: 'vm'
        });



    /** SHARED MEMBERS. */

    /** @const */
    var API_TOKEN = '10ef6c7b010719fb';

    /** @type {boolean} */
    var currentlyPlaying = null,
    isApiInitialised     = false;

    /** @type {Promise<void>} */
    var scriptLoadedPromise;





    /**
     * Renders Youku player and loads video with given ID.
     *
     * @param {ng.IQService} $q
     * @param {ng.IScope} $scope
     * @param {ng.IWindowService} $window
     * @param {LoggerFactory} LoggerFactory
     */
    function YoukuController(
        $q,
        $scope,
        $window,
        LoggerFactory
    ){

        /** @type {angular.IController} */
        var vm        = this;





        /* ===== PRIVATE MEMBERS ============================================ */


        var isInitialised = false;


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'YoukuController', false );





        /* ===== EXPOSE TO THE CONTROLLER =================================== */


        vm.video = {
            id:       null,
            visible:  false,
            toggle:   toggle
        };





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        vm.$onInit = function() {};

        function toggle(){
            vm.video.visible = !vm.video.visible;
            vm.play          = vm.video.visible;

            if ( vm.play ) playVideo();
        }





        /* ===== PRIVATE FUNCTIONS ========================================== */


        // Uni-directional
        vm.$onChanges = function( changesObject ) {
            if ( changesObject.id && changesObject.id.currentValue && !isInitialised ) {
                vm.video.id   = changesObject.id.currentValue;
                if ( !isApiInitialised ) initApi();
                isInitialised = true;
            }
        };


        // Bi-directional
        $scope.$watch( 'vm.play', function ( shouldPlay) {
            if ( shouldPlay == vm.video.visible ) return;

            if ( isInitialised && shouldPlay) {

                // 1. Turn off any other video first
                if ( currentlyPlaying ){
                    currentlyPlaying.toggle();
                }

                // 2. Play
                currentlyPlaying = vm.video;
                vm.video.toggle();

            } else if ( isInitialised && !shouldPlay ){
                vm.video.visible = false;
                currentlyPlaying = null;
            }
        });


        function initApi(){
            var defer = $q.defer();

            var script        = document.createElement( 'script' );
            script.src        = "https://player.youku.com/jsapi";

            var firstScriptTag = document.getElementsByTagName( 'script' )[ 0 ];
            firstScriptTag.parentNode.insertBefore( script, firstScriptTag );
            isApiInitialised = true;

            script.onload   = function() { defer.resolve(); };
            script.onerror  = function() { defer.reject(); }

            scriptLoadedPromise = defer.promise;
        }


        function playVideo(){
            scriptLoadedPromise.then( function() {
                try {
                    new $window.YKU.Player( 'youkuplayer-' + vm.video.id, {
                        styleid:        '0',
                        client_id:      API_TOKEN,
                        vid:            vm.video.id, //video id
                        newPlayer:      true, //newest player version
                        autoplay:       true,
                        show_related:   false, // show related video after playing
                        events: {
                            onPlayerReady: function(){},
                            onPlayStart: function(){},
                            onPlayEnd: function(){}
                        }
                    });
                } catch ( err ){
                    logger.error( "Youku player cannot be initialised due to critical error.", err );
                }
            }).catch( function( err ){
                logger.error( "A script for the Youku player could not load properly and the video won't be initialised.", err );
            });
        }


    }


    YoukuController.$inject = [ '$q', '$scope', '$window', 'LoggerFactory' ];
})();
